"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlowerComponent = void 0;
const gotti_1 = require("gotti");
const Constants_1 = require("../../../Shared/Constants");
class FlowerComponent extends gotti_1.Component {
    constructor(state, growTimeIntervals) {
        super(Constants_1.SYSTEMS.FLOWER);
        this.growTimeIntervals = [];
        this.state = state;
        this.growTimeIntervals = growTimeIntervals;
        this.updateGrownState();
    }
    updateGrownState() {
        const prev = this.grownState;
        if (this.state.elapsedTimeAlive < this.growTimeIntervals[0]) {
            this.grownState = "planted";
        }
        else if (this.state.elapsedTimeAlive < this.growTimeIntervals[1]) {
            this.grownState = "sapling";
        }
        else {
            this.grownState = "flower";
        }
        return prev !== this.grownState;
    }
    updateTimeAlive(delta) {
        //console.error('elapsed time was;', this.state.elapsedTimeAlive)
        this.state.elapsedTimeAlive += delta;
        //console.error('it became', this.state.elapsedTimeAlive);
        if (this.grownState !== "flower") {
            return this.updateGrownState();
        }
        //console.error('grown stqwmnrdf ', this.grownState)
        return false;
    }
    onAdded(entity) {
    }
}
exports.FlowerComponent = FlowerComponent;
//# sourceMappingURL=module.js.map